"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var DIProvider_1 = __importDefault(require("DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var MoreActionsDropdown_1 = __importDefault(require("./MoreActionsDropdown"));
var SharePagePopover_1 = require("./PopoverComponents/SharePagePopover");
var TokensPopover_1 = require("./PopoverComponents/TokensPopover");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TokenApiService_1 = require("Project/Actions/Tokens/Stores/TokenApiService");
var TokenViewStore_1 = require("Project/Actions/Tokens/Stores/TokenViewStore");
var TokenReplacementStore_1 = require("Project/Actions/Tokens/Stores/TokenReplacementStore/TokenReplacementStore");
var ActionButtonsController_1 = require("Project/TopNavigationBar/DefaultNavigationButtons/ActionButtonsController");
var ConvertToTemplatePopover_1 = __importDefault(require("Project/TopNavigationBar/DefaultNavigationButtons/PopoverComponents/ConvertToTemplatePopover"));
var AccountIntegrationsDataStore_1 = require("DataStores/Account/AccountIntegrationsDataStore");
var ActionButtons = (function (_super) {
    __extends(ActionButtons, _super);
    function ActionButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.renderActionButton = function (action) {
            return _this.getComponentForAction(action);
        };
        _this.renderMoreActions = function () {
            var _a = _this.props.isMoreActionsDisabled, disabled = _a.disabled, reason = _a.reason;
            var actionsList = _this.props.getMoreActionsList();
            return (react_1.default.createElement(MoreActionsDropdown_1.default, { project: _this.props.projectStore, actionsList: actionsList, disabled: disabled || _this.props.shouldDisableButtonAccess, disabledReason: reason }));
        };
        var _a = _this.props, apiBaseUrl = _a.apiBaseUrl, projectStore = _a.projectStore, rootDataStore = _a.rootDataStore, tokenStore = _a.tokenStore, modal = _a.modal, project = _a.project, telemetry = _a.telemetry;
        _this.tokenApiService = new TokenApiService_1.TokenApiService(apiBaseUrl);
        _this.tokenReplacementStore = new TokenReplacementStore_1.TokenReplacementStore(projectStore, project, _this.tokenApiService, telemetry);
        _this.tokenViewStore = new TokenViewStore_1.TokenViewStore(tokenStore, projectStore, modal, rootDataStore.userDataStore.isAdmin);
        return _this;
    }
    ActionButtons.prototype.componentWillUnmount = function () {
        this.tokenViewStore.cleanup();
    };
    ActionButtons.prototype.render = function () {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)([
                "hero-actions-container",
                "navigation-actions",
                { disabled: this.props.shouldDisableButtonAccess },
            ]) },
            this.props.getActionsList().map(this.renderActionButton),
            react_1.default.createElement("div", { className: "navigation-actions__button-container navigation-actions__button-more-actions" }, this.renderMoreActions())));
    };
    ActionButtons.prototype.getComponentForAction = function (action) {
        var disabled = action.disabled;
        var disabledReason = disabled ? action.disabledReason : undefined;
        var _a = this.props, projectStore = _a.projectStore, rootDataStore = _a.rootDataStore, shouldDisableButtonAccess = _a.shouldDisableButtonAccess, tokenStore = _a.tokenStore, telemetry = _a.telemetry, inviteNewUserModal = _a.inviteNewUserModal, modal = _a.modal, dragStore = _a.dragStore, usingFeature = _a.usingFeature;
        if (action.name === ActionButtonsController_1.TopNavigationButtonsNames.ShareWithTeam) {
            return (react_1.default.createElement(SharePagePopover_1.SharePagePopoverComponent, { action: action, inviteNewUserModal: inviteNewUserModal, key: action.name, projectStore: projectStore, rootDataStore: rootDataStore, shouldDisableButtonAccess: disabled || shouldDisableButtonAccess, telemetry: telemetry, modal: modal }));
        }
        if (action.name === ActionButtonsController_1.TopNavigationButtonsNames.Tokens) {
            return (react_1.default.createElement(DIProvider_1.default, { container: function () {
                    var container = new inversify_1.Container();
                    container
                        .bind(AccountIntegrationsDataStore_1.AccountIntegrationsDataStore)
                        .toConstantValue(rootDataStore.getAccountIntegrationsDataStore());
                    return container;
                }, key: action.internalName },
                react_1.default.createElement(TokensPopover_1.TokensPopoverComponent, { action: action, projectStore: projectStore, telemetry: telemetry, tokenStore: tokenStore, tokenViewStore: this.tokenViewStore, modal: modal, tokenReplacementStore: this.tokenReplacementStore, usingFeature: usingFeature, dragStore: dragStore, isUserAdmin: this.props.rootDataStore.userDataStore.isAdmin })));
        }
        if (action.name === ActionButtonsController_1.TopNavigationButtonsNames.ConvertToTemplate) {
            return react_1.default.createElement(ConvertToTemplatePopover_1.default, { action: action, key: action.internalName });
        }
        return (react_1.default.createElement("div", { className: "navigation-actions__button-container", key: action.name },
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: action.icon, className: action.actionClass, disabled: disabled || shouldDisableButtonAccess, disabledReason: disabledReason, href: action.href, size: kaleidoscope_1.ButtonSize.Small, onClick: action.onClick, tooltip: {
                    content: action.name,
                    size: action.tooltipSize,
                    position: kaleidoscope_1.TooltipPosition.Bottom,
                } })));
    };
    ActionButtons = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ActionButtons);
    return ActionButtons;
}(react_1.default.Component));
exports.default = ActionButtons;
